import styled from 'styled-components';

export const RcQuotesStyles = styled.div`
    padding: 20px;
    width: 100%;
    max-width: 1400px;
    margin: auto;

    .failed-quotations-block {
        margin-top: 120px;
    }
    .failed-quotations-block img {
        width: 100%;
        display: block;
        aspect-ratio: 6/3;
        object-fit: contain;
        mix-blend-mode: multiply;
    }
`;

export const LambdaLoaderCard = styled.div`
  @keyframes fadeInSlide {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0%, 100% {
      alpha: 1;
    }
    50% {
      box-shadow: 0 2px 8px rgba(0, 154, 81, 0.2);
    }
  }

  background-color: #ffffff;
  background-image: linear-gradient(135deg, #e8f5e9 0%, #f1f8f6 100%);
  border-radius: 1rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 70px;
  box-shadow: 0 2px 8px rgba(0, 154, 81, 0.1);
  border: 1px solid rgba(0, 154, 81, 0.15);
  animation: fadeInSlide 0.6s ease-out, pulse 2s ease-in-out infinite;
  transition: all 0.3s ease-in-out;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 166, 81, 0.2);
    transform: translateY(-2px);
  }
`;

export const LambdaLoaderSpinner = styled.div`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  animation: spin 1s linear infinite;
`;

export const LambdaLoaderText = styled.p`
  @keyframes fadeInText {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  margin-bottom: 0;
  font-size: 0.9rem;
  animation: fadeInText 0.8s ease-out;
  color: #666;
`;
